<span
  ><i
    ><u>{{ payload.sender }}</u></i
  >
  has sent you a notification with message: "{{ payload.message }}"</span
>
